// extracted by mini-css-extract-plugin
module.exports = {"container":"DeleteModal-module__container--1L-mR","title":"DeleteModal-module__title--2mOV4","text":"DeleteModal-module__text--1SWkw","footer":"DeleteModal-module__footer--3Cs6D"};